import { combineReducers } from "redux-immutable";

import assignmentsFilterReducer from "../../features/assignmentsFilter/state/reducers";
import { dropdownsReducer } from "../../features/dropdowns/state";
import ParentUiState from "../models/ParentUiState";

export default combineReducers(
  {
    dropdowns: dropdownsReducer,
    assignmentsFilter: assignmentsFilterReducer
  },
  () => new ParentUiState() as any
);
